<template>
  <div id="businessList">
    <div class="container">
      行业应用
      <el-select v-model="query.businessId" placeholder="请选择行业" clearable @change="getData()" style="margin-right:0.520833rem">
    <el-option
      v-for="item in BusinessList"
      :key="item.id"
      :label="item.busName"
      :value="item.id">
    </el-option>
      </el-select>
      <el-button type="success" icon="el-icon-s-order" @click="addNew()"
        >添加</el-button
      >
      <el-button
        type="danger"
        icon="el-icon-delete"
        @click="handleDelete(deleteArr)"
        >批量删除</el-button
      >
      <el-table
        :data="tableData"
        border
        @selection-change="handleSelectionChange"
        style="width: 100%"
         @sort-change="sortChange"
      >
        <el-table-column
          type="selection"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column label="所属行业">
          <template slot-scope="scope">
            <span
              v-for="item in BusinessList"
              :key="item.id"
              v-show="scope.row.businessId == item.id"
              >{{ item.busName }}</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="title" label="内容">
        </el-table-column>
        <el-table-column prop="sort" label="排序"> </el-table-column>

        <el-table-column prop="updateTime" label="创建时间"  >
          <template slot-scope="scope">
                 {{scope.row.updateTime | seTimeFilter('sjx')}}
          </template>
           </el-table-column>
           
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button
              type="text"
              icon="el-icon-edit"
              @click="addNew(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="text"
              icon="el-icon-delete"
              class="red"
              @click="handleDelete(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageNo"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
    </div>
     
  </div>
</template>

<script>
import { getIndustry, getBusinessList, delIndustry } from "@/api/manage";
export default {
  data() {
    return {
      query: {
        pageNo: 1,
        pageSize: 10,
        sortType:'a',
        businessId:''
      },
      pageTotal:0,
      tableData: [],
      deleteArr: [],
      BusinessList: [],
    };
  },
  created() {
    this.getData();
    this.getList();
  },
  mounted() {},
  methods: {
    handlePageChange(val) {
      //翻页功能
          this.$set(this.query, 'pageNo', val);
          this.getData();
      },
    async getList() {
      //获取行业应用列表
      let res = await getBusinessList({ pageNo: 1, pageSize: 9999 });
      if (res.code == "200") {
        this.BusinessList = res.data;
        console.log("getBusinessList", this.BusinessList);
      } else {
        this.BusinessList = [];
      }
    },
    async getData() {
      //获取行业应用数据
      let res = await getIndustry(this.query);
      if (res.code == "40001") {
      } else if (res.code == "200") {
        this.pageTotal=+res.total
        this.tableData = res.data;
      }
    },
    handleSelectionChange(val) {
      //多选操作,批量删除
      this.deleteArr = [];
      val.map((item) => {
        this.deleteArr.push(item.id);
      });
    },
    addNew(data) {
      //新增或编辑
      if (!data) {
        this.$router.replace({
          name: "IndustryAdd",
          params: { typeOf: "add",total:this.pageTotal },
        });
      } else {
          let replaceTxt = 'http://116.206.94.117:8195//uploading'
      let newTxt = 'http://101.89.182.189:8191//uploading'
      let text = encodeURI(decodeURI(data.text).replace(new RegExp(replaceTxt,'g'),newTxt));
        this.$router.replace({
          name: "IndustryAdd",
          params: {
            typeOf: "edit",
            id: data.id,
            text: text,
            businessId: data.businessId,
            title:data.title,
            sort:data.sort
          },
        });
      }
      
    },
    handleDelete(ids) {
      //删除或批量删除
      if (ids.length == 0) {
        return this.$message.error("未选择删除项");
      }
      this.$confirm("此操作将永久删除该行业应用, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let param = {};
          param.ids = Array.isArray(ids)
            ? JSON.stringify(ids)
            : JSON.stringify([ids]);
          let res = await delIndustry(param);
          if (res.code == 200) {
            if((JSON.parse(param.ids)).length==this.tableData.length){
             this.query.pageNo--
           }
            this.$message.success("删除成功！");
            this.getData();
            this.getList();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    sortChange(){
         this.query.sortType?this.query.sortType='':this.query.sortType='a'
          this.getData()
      }
  },
};
</script>

<style lang="less" scoped>
#businessList {
  height: 100%;
}
.container {
  padding: 30px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 5px;
}
.red {
  color: #f56c6c;
}
.el-table /deep/ th{
  overflow: unset;
}
</style>